module.exports = __webpack_public_path__ + "common/search/icon-check-black-1dec9ec408a1ee0af6a1be55f279acfa.svg";